@if (loading$ | async) {
  <div class="loader-overlay">
    <div class="loader-spinner"></div>
  </div>
}
